import { mediaQueryStyles } from "@newsela/angelou";
const { mediaQuery: breakpoint } = mediaQueryStyles;

export const bannerCss = {
  marginBottom: "24px",
  maxWidth: "860px",
  alignItems: "center",
};

export const bannerBodyCss = {
  display: "flex",
  margin: 0,
  a: {
    color: "#04337A",
  },
  [breakpoint.upTo("xs")]: {
    flexDirection: "column",
    alignItems: "start",
  },
};

export const questionCss = {
  marginRight: "8px",
};
